import cx from 'classnames';
import React from 'react';

interface Props {
  prefix?: React.ReactNode;
  status?: 'warning';
  className?: string;
}

export const ListItem = ({ children, prefix, status, className }: React.WithChildren<Props>) => {
  return (
    <div className={cx('flex w-full items-start gap-2', className)}>
      {prefix}
      <div className="flex w-full flex-col items-start">
        {status === 'warning' && <div className="absolute bottom-0 left-0 top-0 w-1 bg-warning-48" />}
        {children}
      </div>
    </div>
  );
};
